import { render, staticRenderFns } from "./SHeaderNotice.vue?vue&type=template&id=43e88744&scoped=true&"
import script from "./SHeaderNotice.vue?vue&type=script&lang=js&"
export * from "./SHeaderNotice.vue?vue&type=script&lang=js&"
import style0 from "./SHeaderNotice.vue?vue&type=style&index=0&id=43e88744&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e88744",
  null
  
)

export default component.exports